import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  {
    path: 'pricing123',
    loadComponent: () =>
      import('./components/pricing/pricing.component').then(m => m.PricingComponent),
  },
  {
    path: 'comingsoon',
    loadComponent: () =>
      import('./components/comingsoon/comingsoon.component').then(m => m.ComingsoonComponent),
  },
  {
    path: 'aboutus',
    loadComponent: () =>
      import('./components/aboutus/aboutus.component').then(m => m.AboutusComponent),
  },
  {
    path: 'contactus',
    loadComponent: () =>
      import('./components/contactuspage/contactuspage.component').then(m => m.ContactuspageComponent),
  },
  {
    path: 'blog',
    loadComponent: () =>
      import('./components/blog/blog.component').then(m => m.BlogComponent),
  },
  {
    path: 'registration',
    loadComponent: () =>
      import('./components/registration-form/registration-form.component').then(
        m => m.RegistrationFormComponent,
      ),
  },
  {
    path: 'registrationsuccess',
    loadComponent: () =>
      import('./components/registration-form/registration-success/registration-success.component').then(
        m => m.RegistrationSuccessComponent,
      ),
  },
  {
    path: 'privacy',
    loadComponent: () => import('./privacy/privacy.component').then(m => m.PrivacyComponent),
  },
  {
    path: 'terms-and-conditions',
    loadComponent: () =>
      import('./termsConditions/termsConditions.component').then(m => m.TermsConditionsComponent),
  },
  {
    path: 'sales',
    loadComponent: () =>
      import('./components/contact-sales/contact-sales.component').then(m => m.ContactSalesComponent),
  },
  // Developer portal: link-only (not in site navigation), like /onboarding
  {
    path: 'developers',
    loadChildren: () => import('./v2/developer/developer.routes').then(m => m.DEVELOPER_ROUTES),
  },
  {
    path: 'onboarding',
    loadChildren: () =>
      import('./components/client-onboarding/client-onboarding.routes').then(m => m.CLIENT_ONBOARDING_ROUTES),
  },
  {
    path: ':type',
    loadComponent: () =>
      import('./components/home-page/home-page.component').then(m => m.HomePageComponent),
  },
  {
    path: '**',
    loadComponent: () =>
      import('./components/home-page/home-page.component').then(m => m.HomePageComponent),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
